import { Outlet } from "react-router";
import { AdminHeader } from "./AdminHeader";
import { InternalSurfaceBand } from "./InternalSurfaceBand";
import { Sidebar } from "./Sidebar";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { SidebarProvider } from "@/contexts/SidebarContext";
import { ForbiddenBoundary } from "@/components/constant/RequirePagePermission";

export const DashboardLayout = () => (
  <ThemeProvider>
    <SidebarProvider>
      {/* IC canvas: the page background is navy while the content surfaces on
          it (cards, tables, modals) stay white — same treatment as the customer
          selector pages. Only this canvas changes; nothing inside it does. */}
      <div className="flex flex-col h-screen overflow-hidden bg-penn-900 dark:bg-gray-950">
        {/* First child of the flex column, ABOVE AdminHeader: the surface
            identity must not be something a layout can push offscreen. */}
        <InternalSurfaceBand position="static" />
        <AdminHeader />
        <div className="flex flex-1 overflow-hidden">
          <Sidebar />
          <main className="flex-1 overflow-y-auto overflow-x-hidden bg-penn-900 dark:bg-gray-950 p-4 sm:p-6">
            {/* Any admin API 403 swaps the page for the "no permission" panel
                (chrome stays); resets on the next navigation. */}
            <ForbiddenBoundary>
              <Outlet />
            </ForbiddenBoundary>
          </main>
        </div>
      </div>
    </SidebarProvider>
  </ThemeProvider>
);
